import { __assign } from "tslib";
import React from 'react';
function withCssFilter(WrappedComponent) {
    return function (props) {
        var shouldRenderCssFilters = function () {
            var _a = props.styles, backgroundGrayscaleFilter = _a.backgroundGrayscaleFilter, backgroundBlurFilter = _a.backgroundBlurFilter;
            return backgroundBlurFilter > 1 || backgroundGrayscaleFilter;
        };
        var renderStyleTagBackgroundFilters = function () {
            var renderBackgroundFilterElement = props.backgroundFilterElementSelector;
            var _a = props.styles, backgroundGrayscaleFilter = _a.backgroundGrayscaleFilter, backgroundBlurFilter = _a.backgroundBlurFilter;
            var grayScaleValue = backgroundGrayscaleFilter ? '1' : '0';
            var cssFilters = "blur(".concat(backgroundBlurFilter, "px) grayscale(").concat(grayScaleValue, ")");
            return (React.createElement("style", null,
                renderBackgroundFilterElement, "{filter: ".concat(props.fullscreenAnimating ? 'none' : cssFilters, ";\n          transition: filter 0.8s ease;\n        }")));
        };
        if (!shouldRenderCssFilters()) {
            return React.createElement(WrappedComponent, __assign({}, props));
        }
        return (React.createElement("div", { className: 'pro-fullscreen-renderer-wrapper' },
            React.createElement(WrappedComponent, __assign({}, props)),
            renderStyleTagBackgroundFilters()));
    };
}
export default withCssFilter;
//# sourceMappingURL=withCssFilter.js.map